/**
 * Utility functions for domain management
 */

export function isCustomDomain(host: string | null): boolean {
  if (!host) return false

  const mainDomain = process.env.NEXT_PUBLIC_DOMAIN || 'taylora.com'
  const vercelDomain = 'vercel.app'

  if (
    host === mainDomain ||
    host === `www.${mainDomain}` ||
    host.includes(vercelDomain)
  ) {
    return false
  }

  return true
}

export function getCookieDomain(host: string | null): string | undefined {
  if (!host) return undefined

  if (isCustomDomain(host)) {
    return `.${host}`
  }

  const mainDomain = process.env.NEXT_PUBLIC_DOMAIN || 'taylora.com'

  return `.${mainDomain}`
}
